import { render, staticRenderFns } from "./ProjectTitle.vue?vue&type=template&id=b649abd0&scoped=true&"
import script from "./ProjectTitle.vue?vue&type=script&lang=js&"
export * from "./ProjectTitle.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTitle.vue?vue&type=style&index=0&id=b649abd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b649abd0",
  null
  
)

export default component.exports